var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shannon-page-footer"},[_c('div',{staticClass:"footer"},[_c('img',{staticClass:"img",attrs:{"src":require("../../assets/img/Fill.svg"),"alt":""}})])])
}]

export { render, staticRenderFns }